export default {
  adminMenu: [
    {
      id: "3d3a9c57a89b7a8027caccb77362625c",
      text: "商品配置",
      attr: {
        icon: null,
        url: "",
      },
      checked: false,
      selected: false,
      children: [
        {
          id: "be52f59089463123c20a1daf79cb0de5",
          text: "商品管理",
          attr: {
            icon: null,
            url: "/productList",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "3d3a9c57a89b7a8027caccb77362625c",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "be52f59089463123c20a1daf79cb0de6",
          text: "类目管理",
          attr: {
            icon: null,
            url: "/categoryList",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "3d3a9c57a89b7a8027caccb77362625c",
          hasParent: true,
          hasChildren: false,
        },
      ],
      parentId: null,
      hasParent: false,
      hasChildren: true,
    },
    {
      id: "3d3a9c57a89b7a8027caccb77362625c",
      text: "订单管理",
      attr: {
        icon: null,
        url: "",
      },
      checked: false,
      selected: false,
      children: [
        {
          id: "b9d50ed6f759c72ba4739fd1f17c1ad6",
          text: "订单管理",
          attr: {
            icon: null,
            url: "/orderList",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "recycle_order_list_001",
          text: "回收订单",
          attr: {
            icon: null,
            url: "/recyclelist",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "square_order_list_001",
          text: "广场订单",
          attr: {
            icon: null,
            url: "/squarelist",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "withdraw_review_001",
          text: "提现审核",
          attr: {
            icon: null,
            url: "/withdrawreview",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
          hasParent: true,
          hasChildren: false,
        },
      ],
      parentId: null,
      hasParent: false,
      hasChildren: true,
    },
    {
      id: "3d3a9c57a89b7a8027caccb77362625c",
      text: "商家管理",
      attr: {
        icon: null,
        url: "",
      },
      checked: false,
      selected: false,
      children: [
        {
          id: "be52f59089463123c20a1daf79cb0de5",
          text: "商户列表",
          attr: {
            icon: null,
            url: "/companylist",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "3d3a9c57a89b7a8027caccb77362625c",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "be52f59089463123c20a1daf79cb0de5",
          text: "服务人员列表",
          attr: {
            icon: null,
            url: "/cleanerlist",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "3d3a9c57a89b7a8027caccb77362625c",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "be52f59089463123c20a1daf79cbsaj",
          text: "招募列表",
          attr: {
            icon: null,
            url: "/partnerlist",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "3d3a9c57a89b7a8027caccb77362625c",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "partner_applicant_list_001",
          text: "合伙人申请列表",
          attr: {
            icon: null,
            url: "/partnerApplicantList",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "3d3a9c57a89b7a8027caccb77362625c",
          hasParent: true,
          hasChildren: false,
        },
      ],
      parentId: null,
      hasParent: false,
      hasChildren: true,
    },
    {
      id: "3d3a9c57a89b7a8027caccb77362625c",
      text: "配置模块",
      attr: {
        icon: null,
        url: "",
      },
      checked: false,
      selected: false,
      children: [
        {
          id: "be52f59089463123c20a1daf79cb0de5",
          text: "首页配置",
          attr: {
            icon: null,
            url: "/homeManage",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "3d3a9c57a89b7a8027caccb77362625c",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "be52f59089463123c20a1daf79cb0de5",
          text: "优惠券配置",
          attr: {
            icon: null,
            url: "/couponConfig",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "3d3a9c57a89b7a8027caccb77362625c",
          hasParent: true,
          hasChildren: false,
        },
      ],
      parentId: null,
      hasParent: false,
      hasChildren: true,
    },
    {
      id: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
      text: "系统设置",
      attr: {
        icon: null,
        url: null,
      },
      checked: false,
      selected: false,
      children: [
        {
          id: "b9d50ed6f759c72ba4739fd1f17c1ad6",
          text: "用户管理",
          attr: {
            icon: null,
            url: "/accountInfo",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "be52f59089463123c20a1daf79cb0de5",
          text: "添加后台账号",
          attr: {
            icon: null,
            url: "/addUser",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "be52f590894631238176281shagjsajsajh",
          text: "系统设置",
          attr: {
            icon: null,
            url: "/systemconfig",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
          hasParent: true,
          hasChildren: false,
        },
        // {
        //   id: "1f3231aa9e6bf41fb27611a22d34601a",
        //   text: "角色管理",
        //   attr: {
        //     icon: null,
        //     url: "/role",
        //   },
        //   checked: false,
        //   selected: false,
        //   children: [],
        //   parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
        //   hasParent: true,
        //   hasChildren: false,
        // },
        // {
        //   id: "184d5e85715501057a4df10b0fd964fa",
        //   text: "菜单管理",
        //   attr: {
        //     icon: null,
        //     url: "/menu",
        //   },
        //   checked: false,
        //   selected: false,
        //   children: [],
        //   parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
        //   hasParent: true,
        //   hasChildren: false,
        // },
      ],
      parentId: null,
      hasParent: false,
      hasChildren: true,
    },
  ],
  motionMenu: [
    {
      id: "3d3a9c57a89b7a8027caccb77362625c",
      text: "订单管理",
      attr: {
        icon: null,
        url: "",
      },
      checked: false,
      selected: false,
      children: [
        {
          id: "b9d50ed6f759c72ba4739fd1f17c1ad6",
          text: "订单管理",
          attr: {
            icon: null,
            url: "/orderList",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "recycle_order_list_002",
          text: "回收订单",
          attr: {
            icon: null,
            url: "/recyclelist",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "square_order_list_002",
          text: "广场订单",
          attr: {
            icon: null,
            url: "/squarelist",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "withdraw_review_002",
          text: "提现审核",
          attr: {
            icon: null,
            url: "/withdrawreview",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
          hasParent: true,
          hasChildren: false,
        },
      ],
      parentId: null,
      hasParent: false,
      hasChildren: true,
    },
    {
      id: "3d3a9c57a89b7a8027caccb77362625c",
      text: "商家管理",
      attr: {
        icon: null,
        url: "",
      },
      checked: false,
      selected: false,
      children: [
        {
          id: "be52f59089463123c20a1daf79cb0de5",
          text: "商户列表",
          attr: {
            icon: null,
            url: "/companylist",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "3d3a9c57a89b7a8027caccb77362625c",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "be52f59089463123c20a1daf79cb0de5",
          text: "服务人员列表",
          attr: {
            icon: null,
            url: "/cleanerlist",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "3d3a9c57a89b7a8027caccb77362625c",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "partner_applicant_list_001_motion",
          text: "合伙人申请列表",
          attr: {
            icon: null,
            url: "/partnerApplicantList",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "3d3a9c57a89b7a8027caccb77362625c",
          hasParent: true,
          hasChildren: false,
        },
      ],
      parentId: null,
      hasParent: false,
      hasChildren: true,
    },
  ],
  // 服务商菜单 - 只显示订单管理
  serviceMenu: [
    {
      id: "service_order_management",
      text: "订单管理",
      attr: {
        icon: null,
        url: "",
      },
      checked: false,
      selected: false,
      children: [
        {
          id: "service_order_list",
          text: "订单管理",
          attr: {
            icon: null,
            url: "/orderList",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "service_order_management",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "service_recycle_order_list",
          text: "回收订单",
          attr: {
            icon: null,
            url: "/recyclelist",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "service_order_management",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "service_square_order_list",
          text: "广场订单",
          attr: {
            icon: null,
            url: "/squarelist",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "service_order_management",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "service_withdraw_review",
          text: "提现审核",
          attr: {
            icon: null,
            url: "/withdrawreview",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "service_order_management",
          hasParent: true,
          hasChildren: false,
        },
      ],
      parentId: null,
      hasParent: false,
      hasChildren: true,
    },
    {
      id: "3d3a9c57a89b7a8027caccb77362625c",
      text: "商家管理",
      attr: {
        icon: null,
        url: "",
      },
      checked: false,
      selected: false,
      children: [
        {
          id: "be52f59089463123c20a1daf79cb0de5",
          text: "服务人员列表",
          attr: {
            icon: null,
            url: "/cleanerlist",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "3d3a9c57a89b7a8027caccb77362625c",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "partner_applicant_list_001_service",
          text: "合伙人申请列表",
          attr: {
            icon: null,
            url: "/partnerApplicantList",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "3d3a9c57a89b7a8027caccb77362625c",
          hasParent: true,
          hasChildren: false,
        },
      ],
      parentId: null,
      hasParent: false,
      hasChildren: true,
    },
    {
      id: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
      text: "系统设置",
      attr: {
        icon: null,
        url: null,
      },
      checked: false,
      selected: false,
      children: [
        {
          id: "b9d50ed6f759c72ba4739fd1f17c1ad6",
          text: "用户管理",
          attr: {
            icon: null,
            url: "/accountInfo",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "be52f59089463123c20a1daf79cb0de5",
          text: "添加后台账号",
          attr: {
            icon: null,
            url: "/addUser",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "be52f590894631238176281shagjsajsajh",
          text: "系统设置",
          attr: {
            icon: null,
            url: "/systemconfig",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
          hasParent: true,
          hasChildren: false,
        },
      ],
      parentId: null,
      hasParent: false,
      hasChildren: true,
    },
  ],
  serviceMenu2: [
    {
      id: "service_order_management",
      text: "订单管理",
      attr: {
        icon: null,
        url: "",
      },
      checked: false,
      selected: false,
      children: [
        {
          id: "service_order_list",
          text: "订单管理",
          attr: {
            icon: null,
            url: "/orderList",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "service_order_management",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "service2_recycle_order_list",
          text: "回收订单",
          attr: {
            icon: null,
            url: "/recyclelist",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "service_order_management",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "service2_square_order_list",
          text: "广场订单",
          attr: {
            icon: null,
            url: "/squarelist",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "service_order_management",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "service2_withdraw_review",
          text: "提现审核",
          attr: {
            icon: null,
            url: "/withdrawreview",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "service_order_management",
          hasParent: true,
          hasChildren: false,
        },
      ],
      parentId: null,
      hasParent: false,
      hasChildren: true,
    },
    {
      id: "3d3a9c57a89b7a8027caccb77362625c",
      text: "商家管理",
      attr: {
        icon: null,
        url: "",
      },
      checked: false,
      selected: false,
      children: [
        {
          id: "be52f59089463123c20a1daf79cb0de5",
          text: "服务人员列表",
          attr: {
            icon: null,
            url: "/cleanerlist",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "3d3a9c57a89b7a8027caccb77362625c",
          hasParent: true,
          hasChildren: false,
        },
        {
          id: "partner_applicant_list_001_service2",
          text: "合伙人申请列表",
          attr: {
            icon: null,
            url: "/partnerApplicantList",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "3d3a9c57a89b7a8027caccb77362625c",
          hasParent: true,
          hasChildren: false,
        },
      ],
      parentId: null,
      hasParent: false,
      hasChildren: true,
    },
    {
      id: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
      text: "系统设置",
      attr: {
        icon: null,
        url: null,
      },
      checked: false,
      selected: false,
      children: [
        {
          id: "be52f590894631238176281shagjsajsajh",
          text: "系统设置",
          attr: {
            icon: null,
            url: "/systemconfig",
          },
          checked: false,
          selected: false,
          children: [],
          parentId: "7e30f4c9f1b81ed5f81fe82e3e99ae3a",
          hasParent: true,
          hasChildren: false,
        },
      ],
      parentId: null,
      hasParent: false,
      hasChildren: true,
    },
  ],
};
